import { memo } from 'react'

import { CopyAll } from '@mui/icons-material'
import { Avatar, Box, IconButton, Tooltip, Typography } from '@mui/material'
import { motion } from 'motion/react'
import CopyToClipboard from 'react-copy-to-clipboard'

import { CodeInline } from '@shared/components/MaterialUIEnhancements/CodeInline'
import { popInOut } from '@shared/utils/support'
import { useUserInfo } from 'hooks/useUserInfo'
import { getAvatarColor, getContrastText, getInitials } from 'utils/avatar'

const ProfileRaw = () => {
  const { data: userInfo } = useUserInfo()

  const displayName = userInfo?.name || [userInfo?.givenName, userInfo?.familyName].filter(Boolean).join(' ') || null

  return (
    <Box
      sx={{ width: '100%' }}
      component={motion.div}
      variants={popInOut}
      initial="hidden"
      animate="visible"
      exit="hidden"
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Avatar
          sx={{
            width: 64,
            height: 64,
            fontSize: 24,
            bgcolor: getAvatarColor(displayName),
            color: `${getContrastText(getAvatarColor(displayName))}`,
          }}
          alt={displayName || 'Profile'}
          src={userInfo?.picture || undefined}
        >
          {!userInfo?.picture && getInitials(displayName, userInfo?.givenName, userInfo?.familyName)}
        </Avatar>
        <Box>
          {displayName && <Typography variant="heading-lg">{displayName}</Typography>}
          {userInfo?.email && <Typography variant="text">{userInfo.email}</Typography>}
        </Box>
      </Box>

      {userInfo?.sub && (
        <>
          <Typography variant="heading-xs">User ID</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1, mt: 0.5 }}>
            <CodeInline sx={{ width: '100%' }} noWrap>
              {userInfo.sub}
            </CodeInline>
            <CopyToClipboard text={userInfo.sub}>
              <Tooltip title="Click to copy" placement="right">
                <IconButton size="small">
                  <CopyAll fontSize="inherit" />
                </IconButton>
              </Tooltip>
            </CopyToClipboard>
          </Box>
        </>
      )}

      {userInfo?.preferredUsername && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="heading-xs">Username</Typography>
          <Typography variant="text">{userInfo.preferredUsername}</Typography>
        </Box>
      )}
    </Box>
  )
}

export const Profile = memo(ProfileRaw)
